module.exports = __webpack_public_path__ + "img/project-2.383c1ced.jpg";